import React from 'react'
import './ProjectCover.css'

const ProjectCover = () => {
  return (
    <div className='project-cover-container'>
        <div className="hl-0"></div>
        <div className="hl-1"></div>
        <div className="hl-2"></div>
        <div className="hl-3"></div>
        <div className="about-company" style={{'color':'#000', 'width':'230px'}}>Chawla<br/> Structural <br/> Design <br/> Engineers <br/> & <br/> Consultant</div>
      <div className="about-projects-header">PROJECTS</div>
    </div>
  )
}

export default ProjectCover
